import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Card, Loader, Message } from 'semantic-ui-react';

import DataRequestWideCard from '../../components/data-request-wide-card';

const DataRequestsListing = ({
  isLoading,
  isError,
  requests,
  isInfluencerMode,
  onRequestReviewButtonClick,
  onRequestAccepted,
  onRequestDeclined,
}) => {
  const canRenderRequests = _.size(requests) > 0 && !isError && !isLoading;
  return (
    <Card.Group cardsPerRow="one">
      {
        canRenderRequests && _.map(requests, (request => (
          <DataRequestWideCard
            {...request}
            isInfluencerMode={isInfluencerMode}
            onRequestReviewButtonClick={onRequestReviewButtonClick}
            onRequestAccepted={onRequestAccepted}
            onRequestDeclined={onRequestDeclined}

          />
        )))
      }
      {
        !isLoading && isError &&
        <Card fluid>
          <Message fluid error content="Something went wrong. Please try again later." />
        </Card>
      }
      {
        !isLoading && !isError && !canRenderRequests &&
        <Card fluid>
          <Message info content="No requests yet." />
        </Card>
      }
      {
        isLoading &&
        <Loader active content="Loading..." />
      }
    </Card.Group>
  );
};

DataRequestsListing.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  requests: PropTypes.array.isRequired,
  onRequestReviewButtonClick: PropTypes.func,
  onRequestAccepted: PropTypes.func,
  onRequestDeclined: PropTypes.func,
  isInfluencerMode: PropTypes.bool,
};

DataRequestsListing.defaultProps = {
  isInfluencerMode: false,
  onRequestReviewButtonClick: _.noop,
  onRequestDeclined: _.noop,
  onRequestAccepted: _.noop,

};

export default DataRequestsListing;



/** WEBPACK FOOTER **
 ** ./src/components/data-requests-listing/index.js
 **/